import { FormType } from '../../../../form-types';
import { ConstipationFieldAnswers } from '../questions';

export const constipation: FormType<ConstipationFieldAnswers> = {
  name: 'Constipation Consultation',
  questions: [
    {
      key: 'constipation_sexAssignedAtBirth',
      next: {
        condition: { 'constipation_sexAssignedAtBirth.female': true },
        key: 'constipation_pregnancyStatus',
        els: 'constipation_height'
      }
    },
    {
      key: 'constipation_pregnancyStatus',
      next: {
        condition: { 'constipation_pregnancyStatus.yes': true },
        key: 'constipation_ineligible',
        els: 'constipation_consentPregnancy'
      }
    },
    {
      key: 'constipation_consentPregnancy',
      next: {
        condition: { 'constipation_consentPregnancy.consent': true },
        key: 'constipation_height',
        els: 'constipation_nonConsent'
      }
    },
    'constipation_height',
    'constipation_weight',

    'constipation_bloodInStool',

    {
      key: 'constipation_unexplainedWeightLoss',
      next: {
        condition: { 'constipation_unexplainedWeightLoss.yes': true },
        key: 'constipation_ineligible',
        els: 'constipation_anemic'
      }
    },
    {
      key: 'constipation_anemic',
      next: {
        condition: { 'constipation_anemic.yes': true },
        key: 'constipation_ineligible',
        els: 'constipation_bowelHabitChange'
      }
    },
    {
      key: 'constipation_bowelHabitChange',
      next: {
        condition: { 'constipation_bowelHabitChange.yes': true },
        key: 'constipation_ineligible',
        els: 'constipation_bowelMovementsPerWeek'
      }
    },

    'constipation_bowelMovementsPerWeek',
    'constipation_hardStools',
    'constipation_incompleteEvacuation',
    'constipation_straining',
    'constipation_manualAssistance',
    'constipation_blockageSensation',
    'constipation_symptomDuration',
    'constipation_bristolStoolType',
    'constipation_toiletTime',
    'constipation_urgeCantGo',
    'constipation_laxativeUse',
    'constipation_fiberIntake',
    'constipation_waterIntake',
    'constipation_physicalActivity',
    'constipation_hypothyroidism',
    'constipation_diabetes',
    'constipation_neurologicDisorders',
    'constipation_anorectalSurgery',
    'constipation_pelvicFloorDysfunction',
    'constipation_additionalQuestions',
    {
      key: 'constipation_consentTruthfulness',
      next: {
        condition: { 'constipation_consentTruthfulness.consent': true },
        key: 'constipation_consentLubiprostone',
        els: 'constipation_nonConsent'
      }
    },
    {
      key: 'constipation_consentLubiprostone',
      next: {
        condition: { 'constipation_consentLubiprostone.consent': true },
        key: 'constipation_complete',
        els: 'constipation_nonConsent'
      }
    },
    'constipation_complete',
    'constipation_nonConsent',
    'constipation_ineligible'
  ]
};
